module.exports = __webpack_public_path__ + "img/float-btn-cockfigh.c8b45ccb.svg";